import styled from 'styled-components'
import Box from 'components/shared/Box'
import { respondAbove } from 'styles/mediaQueries'

export const Wrapper = styled(Box)`
    background-color: ${({ theme }) => theme.colors.grayscale_0};
    border-radius: 6px;
    padding: 24px 16px;

    input[type='radio'],
    label {
        cursor: pointer;
    }

    @media ${respondAbove.xl} {
        border-radius: 8px;
        padding: 56px 80px;
    }
`

export const BorderBottomBox = styled(Box)`
    border-bottom: 2px solid ${({ theme }) => theme.colors.grayscale_300};
`
